var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner"},[_c('swiper',{ref:"mySwiper",attrs:{"options":_vm.swiperOption}},[_vm._l((_vm.slide),function(item,index){return _c('swiper-slide',{key:index,staticClass:"swiper-slide",style:({
				height: _vm.height,
				background:
					'url(' + item.srcFileName + ') center no-repeat',
			}),nativeOn:{"click":function($event){return _vm.goto(item.url)}}})}),_c('div',{staticClass:"swiper-pagination",attrs:{"slot":"pagination"},slot:"pagination"})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }